<!-- <app-new-header></app-new-header> -->
<div class="main_banner">
    <section class="casestudy text-center">
        <div class="title">
            <h1 class="hero_heading">CTR - The case study</h1>
        </div>
        <!-- <video controls controlsList="nodownload noplaybackrate" disablePictureInPicture poster="../../../../assets/images/new/usecasethumb.png" id="use_case_vid">
            <source src="../../../assets/images/new/use_case_video.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video> -->
          <br><br>
        <p class="hero_para mx-auto">Increase CTR to your keywords and get ranked higher on Google. Google likes
            positive signals.</p>

        <a href="https://wa.me/message/YMIRQRC2ZXZNO1" target="_blank" class="hero_btn text-white">Contact us today</a>

        <div class="container pt-5">
            <div class="row pt-4">
                <div class="col-lg-4 col-md-6 col-sm-12 my-3 px-5">
                    <div class="cards d-flex overflow-hidden">
                        <div class="card_image">
                            <img loading="lazy" src="../../../assets/images/new/map-graph.svg" class="" alt="">
                        </div>
                        <div class="card_body bg-white">
                            <h5 class="text-left">
                                Rankings on steroids!
                            </h5>
                            <img loading="lazy" src="../../../assets/images/new/star.svg" alt="">
                            <p class="text-left">More than 1000's users trust MYVIP</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-md-6 col-sm-12 my-3 px-0 growth position-relative">
                    <img loading="lazy" src="../../../assets/images/new/google-growth.svg" class="gro_img" alt="">
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 my-3 px-5">
                    <div class="cards overflow-hidden">
                        <div class="card_image overflow-hidden">
                            <img loading="lazy" src="../../../assets/images/new/clics_img.png" alt="">
                        </div>
                        <div class="card_body  bg-white">
                            <h5 class="text-left">
                                Increase CTR on keywords
                            </h5>
                            <p class="text-left">And give the positive signal to Google</p>
                            <div class="g_star d-flex">
                                <img loading="lazy" class="gsearch_img" src="../../../assets/images/new/seachc_onsole.png" alt="">
                                <img loading="lazy" class="star_img" src=" ../../../assets/images/new/star-img2.svg" alt="">
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </section>
</div>



<!-- <section class="features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="feature_title text-center">
                    <h2>
                        Does CTR improve the ranking?
                    </h2>
                    <p>Rand Fishkin, an SEO consultant from the renowned MOZ software, conducted <a href="#" class="text-primary "> a case study </a> on
                        increasing CTR. By increasing the number of searches from SERP to his website, <b> his site
                            went
                            from #7 to #1 </b> on targeted keywords.</p>
                </div>
            </div>
            <div class="col-md-12">
                <img loading="lazy" src="../../../../assets/images/new/sitefeatures.jpeg" alt="">
            </div>
            <div class="col-md-12">
                <div class="feature_title pt-5 text-center">
                    <h2>Your ranking on steroids</h2>
                    <p>Get ranked quicker and higher with MYVIP. More than 1,000 customers are using our service
                        to boost their website's organic ranking.
                        Ranking improvement MYVIP big size</p>
                </div>
            </div>
            <div class="col-md-12">
                <img loading="lazy" src="../../../../assets/images/new/GroupGraph.svg" alt="">
            </div>
            <div class="col-md-12">
                <div class="feature_title text-center py-4">
                    <h2>Many reports classify CTR as a powerful SEO factor</h2>
                </div>
                <div class="feature_link mt-3">
                    <div class="row justify-content-center">
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <a href="#" class="mx-auto">
                                <p>Read Worldstream Report</p>
                                <img loading="lazy" class="mt-3" src="../../../../assets/images/new/WORLDSTREAM.png" alt="">
                            </a>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <a href="#" class="mx-auto">
                                <p>Read Moz Report</p>
                                <img loading="lazy" class="mt-3" src="../../../../assets/images/new/MOZ.png" alt="">
                            </a>
                        </div>
                    </div>

                </div>
                <div class="row pt-5 justify-content-center">
                    <div class="col-md-6">
                        <img loading="lazy" src="../../../../assets/images/new/TOP-Ranking-Factor-p-500.png" alt="">
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
<section class="faq">
    <div class="container">
        <div class="row">
            <div class="col-md-12">

                <div class="demo">
                    <div class="accordion" id="accordionExample">
                        <div class="card">
                            <div class="card-header" id="headingOne">
                                <h2 class="mb-0">
                                    <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseOne">Is MYVIP a better alternative to Google CTR
                                        bots to
                                        increase the click-through rate? <i class="fa fa-plus" aria-hidden="true"></i></button>
                                </h2>
                            </div>
                            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>MYVIP's home network is similar to an automated traffic bot. It contains
                                        a wide
                                        variety of advanced features to generate organic website traffic and clicks
                                        from
                                        Google's SERPs.
                                        To increase the click-through-rate of your website you simply have to:
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingTwo">
                                <h2 class="mb-0">
                                    <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseTwo">Buy website traffic: Should You Really Do It?
                                        This Will Help
                                        You Decide! <i class="fa fa-plus" aria-hidden="true"></i></button>
                                </h2>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>MYVIP's home network is similar to an automated traffic bot. It contains
                                        a wide
                                        variety of advanced features to generate organic website traffic and clicks
                                        from
                                        Google's SERPs.
                                        To increase the click-through-rate of your website you simply have to:
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingThree">
                                <h2 class="mb-0">
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree"> What features make MYVIP become the best
                                        traffic bot
                                        software? <i class="fa fa-plus" aria-hidden="true"></i></button>
                                </h2>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p>MYVIP's home network is similar to an automated traffic bot. It contains
                                        a wide
                                        variety of advanced features to generate organic website traffic and clicks
                                        from
                                        Google's SERPs.
                                        To increase the click-through-rate of your website you simply have to:
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->